export default function Shimmer(){
    return(
        <>
        <div className="flex flex-wrap justify-center mx-auto mt-20 w-[80%] gap-4">

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

            <div className="w-[30%] sm:w-[45%] md:w-[30%] lg:max-w-[240px] mb-4 relative overflow-hidden">
                <div className="w-full h-40 rounded-xl bg-gray-300 shimmer-animation"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-200"></div>
                    <div className="w-full h-6 mt-2 bg-gray-300 rounded-lg shimmer-animation animation-delay-400"></div>
                </div>
            </div>

        </div>
        </>
    )
}